import { Box, CircularProgress } from '@mui/material';

import { AppraisalHistoryList } from '@modules/_shared/components/appraisal/AppraisalHistoryList';
import type { AppraisalHistoryItem } from '@modules/_shared/components/appraisal/AppraisalHistoryList';
import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';
import type { Currency, IntlLocale } from '@shared/LocaleContext';

type AppraisalHistoryDialogProps = {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  appraisals: AppraisalHistoryItem[];
  currency: Currency;
  locale: IntlLocale;
};

export const AppraisalHistoryDialog = ({
  open,
  onClose,
  loading,
  appraisals,
  currency,
  locale,
}: AppraisalHistoryDialogProps) => {
  const { t } = useLocale();

  return (
    <SlideDialog open={open} onClose={onClose} title={t('Appraisal History')}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <AppraisalHistoryList
          appraisals={appraisals}
          currency={currency}
          locale={locale}
          emptyMessage={t('No appraisal history available')}
        />
      )}
    </SlideDialog>
  );
};
